import styled, { css } from '@xstyled/styled-components'

export const TimerWrapper = styled.div`
  position: relative;
  width: 300px;
  height: 10px;
  max-width: 100%;
  background-color: rgba(255, 255, 255, 0.5);
  border: 1px solid white;
  border-radius: 10px;
  overflow: hidden;
`

interface TimerProgressProps {
  inPlayback?: boolean
  progress: number
}

export const TimerProgress = styled.div.attrs<TimerProgressProps>(
  ({ progress }) => ({
    style: {
      width: `${progress * 100}%`,
    },
  }),
)<TimerProgressProps>`
  ${({ inPlayback }) => css`
    position: absolute;
    left: 0;
    transition: 0.1s;
    height: 100%;
    z-index: ${inPlayback ? '-1' : '-2'};
    background-color: ${inPlayback ? 'green' : 'red'};
  `}
`
